import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageHelmet } from '@/config/helmet';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import FeaturedProducts from '@/components/FeaturedProducts';
import About from '@/components/About';
import GoogleReviews from '@/components/GoogleReviews';
import CallToAction from '@/components/CallToAction';
import Footer from '@/components/Footer';

export default function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const scrollToContact = location.state?.scrollToContact;

  useEffect(() => {
    if (!scrollToContact) return undefined;
    const t = window.setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      navigate(location.pathname, { replace: true, state: {} });
    }, 200);
    return () => window.clearTimeout(t);
  }, [scrollToContact, location.pathname, navigate]);

  useEffect(() => {
    // Proveri refresh i scroll na vrh ako je refresh
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    if (navigationEntry && navigationEntry.type === 'reload') {
      // Scroll na vrh stranice
      window.scrollTo({ top: 0, behavior: 'instant' });
      // Takođe scroll na hero sekciju ako postoji
      setTimeout(() => {
        const heroElement = document.getElementById('hero');
        if (heroElement) {
          heroElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }

  }, []);

  return (
    <div className="min-h-screen">
      <PageHelmet page="home" />
      <Navbar />
      <Hero />
      <About />
      <FeaturedProducts />
      <GoogleReviews />
      <CallToAction />
      <Footer />
    </div>
  );
}
